import { MutableRefObject, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import clsx from 'clsx'

import { KTIcon } from '../../../helpers'
import { useLayout } from '../../core'
import { ToggleComponent } from '../../../assets/ts/components'
import { useAuth } from '../../../../app/modules/auth'
import logoDark from '../../../../app/assets/images/dualipay_logo_black.png'
import logoLight from '../../../../app/assets/images/dualipay_logo_white.png'
import cubeDark from '../../../../app/assets/images/DarkCube.svg'
import cubeLight from '../../../../app/assets/images/LightCube.svg'
import { useThemeMode } from '../../../partials'

type PropsType = {
  sidebarRef: MutableRefObject<HTMLDivElement | null>
}

const SidebarProjectName = (props: PropsType) => {
  const { config } = useLayout()
  const { routeByRoleRedirect } = useAuth()
  const toggleRef = useRef<HTMLDivElement>(null)

  const { mode } = useThemeMode()

  const appSidebarDefaultMinimizeDesktopEnabled =
    config?.app?.sidebar?.default?.minimize?.desktop?.enabled
  const appSidebarDefaultCollapseDesktopEnabled =
    config?.app?.sidebar?.default?.collapse?.desktop?.enabled
  const toggleType = appSidebarDefaultCollapseDesktopEnabled
    ? 'collapse'
    : appSidebarDefaultMinimizeDesktopEnabled
    ? 'minimize'
    : ''
  const toggleState = appSidebarDefaultMinimizeDesktopEnabled ? 'active' : ''
  const appSidebarDefaultMinimizeDefault = config.app?.sidebar?.default?.minimize?.desktop?.default

  useEffect(() => {
    setTimeout(() => {
      const toggleObj = ToggleComponent.getInstance(toggleRef.current!) as ToggleComponent | null

      if (toggleObj === null) {
        return
      }

      // Add a class to prevent sidebar hover effect after toggle click
      toggleObj.on('kt.toggle.change', function () {
        // Set animation state
        props.sidebarRef.current!.classList.add('animating')

        // Wait till animation finishes
        setTimeout(function () {
          // Remove animation state
          props.sidebarRef.current!.classList.remove('animating')
        }, 300)
      })
    }, 600)
  }, [toggleRef, props.sidebarRef])

  return (
    <div className='app-sidebar-logo px-6' id='kt_app_sidebar_logo'>
      <Link to={routeByRoleRedirect}>
        <div className='app-sidebar-logo-default'>
          {mode === 'light' ? (
            <img style={{ height: '30px' }} src={logoDark} alt='logo' />
          ) : (
            <img style={{ height: '30px' }} src={logoLight} alt='logo' />
          )}
        </div>
        <div className='app-sidebar-logo-minimize'>
          {mode === 'light' ? (
            <img style={{ height: '20px' }} src={cubeDark} alt='mini_logo' />
          ) : (
            <img style={{ height: '20px' }} src={cubeLight} alt='mini_logo' />
          )}
        </div>
      </Link>

      {(appSidebarDefaultMinimizeDesktopEnabled || appSidebarDefaultCollapseDesktopEnabled) && (
        <div
          ref={toggleRef}
          id='kt_app_sidebar_toggle'
          className={clsx(
            'app-sidebar-toggle btn btn-icon btn-shadow btn-sm btn-color-muted btn-active-color-primary body-bg h-30px w-30px position-absolute top-50 start-100 translate-middle rotate',
            { active: appSidebarDefaultMinimizeDefault }
          )}
          data-kt-toggle='true'
          data-kt-toggle-state={toggleState}
          data-kt-toggle-target='body'
          data-kt-toggle-name={`app-sidebar-${toggleType}`}
        >
          <KTIcon iconName='double-left' className='fs-2 rotate-180' />
        </div>
      )}
    </div>
  )
}

export { SidebarProjectName }
